import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.qbooks.SalesInvoiceShippingDetailsSection', {
    title: 'Shipping details',
    shippingToLabel: 'Shipping to',
    shippingToPlaceholder: 'Enter shipping to',
    shipViaLabel: 'Ship via',
    shipViaPlaceholder: 'Enter a text',
    shippingDateLabel: 'Shipping date',
    shippingDatePlaceholder: 'Enter shipping date',
    trackingNumberLabel: 'Tracking number',
    trackingNumberPlaceholder: 'Enter tracking number',
    shippingFromLabel: 'Shipping from',
    shippingFromPlaceholder: 'Enter shipping from',
    shippingPriceLabel: 'Shipping price ({currency})',
    shippingPricePlaceholder: 'Enter shipping price',
    shippingTaxCodeLabel: 'Shipping tax rate',
    shippingTaxCodePlaceholder: 'Select shipping tax rate',
});
